import Flickity from 'flickity';
import debug from 'bows';
import breakpoints from '../_breakpoints';

const log = debug('news');

class News {
	constructor(node) {
		this.node = node;
		this.wrap = this.node.querySelector('.news__items');
		this.items = Array.from(this.wrap.querySelectorAll('.news__item'));

		this.flickity = new Flickity(this.wrap, {
			adaptiveHeight: false,
			autoPlay: false,
			cellAlign: 'left',
			prevNextButtons: false,
			watchCSS: true,
			wrapAround: false
		});

		window.addEventListener('site.resize', this.resize.bind(this));
		this.adjustPHeight();
	}

	// Measure height of each cards contents and adjust the height of the excerpt
	adjustPHeight() {
		// log(document.body.clientWidth);
		// log('bp', breakpoints.medium);
		if (this.items) {
			this.items.forEach((card) => {
				let cardContent = card.querySelector('.card__excerpt p');
				if (document.body.clientWidth >= breakpoints.medium) {

					// Get inner height of card without padding
					let cardComputedStyle = getComputedStyle(card)
					let cardHeight = card.clientHeight; // height with padding
					cardHeight -= parseFloat(cardComputedStyle.paddingTop) + parseFloat(cardComputedStyle.paddingBottom);

					// Get height of card header elements
					let cardPub = card.querySelector('.card__publication');
					let cardPubHeight = cardPub ? this.getTotalHeight(cardPub) : 0;
					let cardDate = card.querySelector('.card__date');
					let cardDateHeight = cardDate ? this.getTotalHeight(cardDate) : 0;
					let cardTitle = card.querySelector('.card__title');
					let cardTitleHeight = cardTitle ? this.getTotalHeight(cardTitle) : 0;
					//log(cardHeight);
					let cardMetaHeight = cardPubHeight + cardDateHeight + cardTitleHeight;

					// Get available height for card content
					let cardContentHeightMax = cardHeight - cardMetaHeight;

					// Find line height of excerpt and return new height based on available space
					let cardLineHeight = this.getLineHeight(cardContent);

					// Capture any margin and subtract that from available height
					let excerptComputedStyle = getComputedStyle(cardContent);
					let excerptMarginTop = parseInt(excerptComputedStyle.getPropertyValue('margin-top'), 10);
					cardContentHeightMax -= excerptMarginTop;

					// Find height for card content based on available lines
					let newCardContentHeight = cardLineHeight * (Math.floor(cardContentHeightMax / cardLineHeight));
					cardContent.style.height = newCardContentHeight + 'px';
					cardContent.style.overflow = 'hidden';
				} else {
					// Reset attributes on mobile
					cardContent.style.height = '';
					cardContent.style.overflow = '';
					log('noop');
				}
			});
		}
	}

	resize() {
		this.adjustPHeight();
	}

	getLineHeight(element) {
		let temp = document.createElement(element.nodeName);
		temp.setAttribute("style", "margin:0px;padding:0px;font-family:" + element.style.fontFamily + ";font-size:" + element.style.fontSize);
		temp.innerHTML = "test";
		temp = element.parentNode.appendChild(temp);
		let calcLineHeight = temp.clientHeight;
		temp.parentNode.removeChild(temp);
		return calcLineHeight;
	}

	getTotalHeight(element) {
		let style = window.getComputedStyle(element);
		let height = ['height', 'padding-top', 'padding-bottom', 'margin-top', 'margin-bottom']
			.map((key) => parseInt(style.getPropertyValue(key), 10))
			.reduce((prev, cur) => prev + cur);
		return height;
	}
}

export default News;
